import './Input.scss'

import { useEffect, useRef, useState } from 'react'

const Input = ({ control, type = 'text', label = '', disabled = false, onChange, defaultValue, placeholder = '', className }) => {
    const inputRef = useRef()

    const onInputChange = () => {
        let value = inputRef.current.value
    
        if (type === 'number') {
            value = value.replace(/[^0-9]/g, '')
            value = value === '' ? '' : parseFloat(value)
        }
    
        if (control) control.setValue(value)
        if (onChange) onChange(value)
    }

    const updateFromValue = (value) => {
        if (String(value ?? '') !== inputRef.current.value) {
            inputRef.current.value = value
            if (onChange) onChange(value)
        }
    }

    useEffect(() => {
        if (control) updateFromValue(control.value ?? '')
    }, [control?.value])

    useEffect(() => {
        updateFromValue((control ? control.value : defaultValue) ?? '')
    }, [])

    return (
        <div className="input flex-column">
            {label && <label>{label}</label>}
            <div className="position-relative">
                <input className={className} type={type} onChange={onInputChange} ref={inputRef} disabled={disabled} placeholder={placeholder} inputMode={type === 'number' ? 'numeric' : null} />
            </div>
        </div>
    )
}

export default Input